const Director = 'Director'
const SalesExecutive = 'SalesExecutive'

export default [
  {
    path: '/main_daily',
    name: 'MainDaily',
    component: () => import('@/_backoffice/_registrations/components/reports/MainDaily.vue'),
    meta: {
      auth: true,
      roles: [Director, SalesExecutive],
    },
    
  },
]